import { Navigation } from './components'
import { IntegrationDashboardPage } from '@/pages/ZocdocAdmin'

/**
 * The Zocdoc integration dashboard as a Super Admin section.
 *
 * It was a top-level nav entry at `/integration-dashboard` open to care coordinators; it now lives
 * under `/super`, whose layout already answers the access question — `ProtectedRoute level="system"`
 * — so this page carries no guard of its own. The dashboard component is unchanged and brings its
 * own page shell; only the tab bar is added above it.
 */
export function Integrations() {
  return (
    <>
      <Navigation />
      <IntegrationDashboardPage />
    </>
  )
}
